import { Option } from '~/components/Select/Select';

interface JSONCarrierFormField {
  rank: number;
  key: string;
  label: string;
  placeholder_text: Maybe<string>;
  field_type: string;
  display_type: string;
  min_length: Maybe<number>;
  max_length: Maybe<number>;
  is_required: boolean;
  help_url: Maybe<string>;
  options?: Option[];
  default_value?: boolean | string;
  hidden_by_key?: string;
  hidden_by_value?: boolean | string | undefined;
}

interface CarrierFormField {
  rank: number;
  key: string;
  label: string;
  placeholderText: Maybe<string>;
  fieldType: string;
  displayType: string;
  minLength: Maybe<number>;
  maxLength: Maybe<number>;
  isRequired: boolean;
  helpUrl: Maybe<string>;
  agreementLabels?: string[];
  agreementUrls?: string[];
  options?: Option[];
  defaultValue?: boolean | string;
  hiddenByKey?: string; // if the specified key is present and has a non-null value then hide this parameter
  hiddenByValue?: boolean | string | undefined; // the fields with hiddenByKey will be hidden depending on this value
  tooltip?: string;
  disabled?: boolean;
}

function fromJSON(jsonCarrierFormField: JSONCarrierFormField): Maybe<CarrierFormField> {
  if (!jsonCarrierFormField) return null;

  const serialized: CarrierFormField = {
    rank: jsonCarrierFormField.rank,
    key: jsonCarrierFormField.key,
    label: jsonCarrierFormField.label,
    placeholderText: jsonCarrierFormField.placeholder_text,
    fieldType: jsonCarrierFormField.field_type,
    displayType: jsonCarrierFormField.display_type,
    minLength: jsonCarrierFormField.min_length,
    maxLength: jsonCarrierFormField.max_length,
    isRequired: jsonCarrierFormField.is_required,
    helpUrl: jsonCarrierFormField.help_url,
    options: jsonCarrierFormField.options,
    defaultValue: jsonCarrierFormField.default_value,
    hiddenByKey: jsonCarrierFormField.hidden_by_key,
    hiddenByValue: jsonCarrierFormField.hidden_by_value,
  };

  // Return null if invalid form field
  if (!serialized.rank || !serialized.label || !serialized.key) {
    return null;
  }

  return serialized;
}

export { fromJSON, CarrierFormField, JSONCarrierFormField };
